onComplete(function () {
  // Menublokken - Submenus Large.
  document.querySelectorAll('.menublokken ul.navlist-nav li.nav-item').forEach(navItem => {
    const nestedUl = navItem.querySelector('ul');
    const childCount = nestedUl ? nestedUl.children.length : 0;
    if (childCount > 5) {
      navItem.classList.add('menublok-large');
    }
  });

  // Teamleden.
  const items = document.querySelectorAll('.team-members [class^="col-"]');
  if (items && items.length) {
    const suffixes = ['name', 'function', 'gebied'];
    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      for (let k = 0; k < suffixes.length; k++) {
        const suffix = suffixes[k];
        const nameTargets = item.querySelectorAll('[data-text$="-team-member-' + suffix + '"]');
        for (let j = 0; j < nameTargets.length; j++) {
          const nameTarget = nameTargets[j];
          const nameReference = item.querySelector('[data-reference="' + nameTarget.getAttribute('data-text') + '"]');
          if (nameReference) {
            nameTarget.textContent = nameReference.textContent;
          }
        }
      }
    }
  }

  /*
  // Trap Focus - Modal.
  if (
  	!document.documentElement.hasAttribute('data-logged')
  	|| document.documentElement.getAttribute('data-logged') === 'false'
  ) {
  	const focusableSelector = 'button,[href],input:not([type="hidden"]),select,textarea,[tabindex]:not([tabindex="-1"])'
  	let firstFocusableElement,
  		lastFocusableElement
  			const setFocus = (
  			element = null,
  			event = null,
  		) => {
  			if (event) {
  				event.preventDefault()
  			}
  			if (document.activeElement) {
  				document.activeElement.blur()
  			}
  			if (element) {
  				element.focus()
  			}
  		}
  		// Function to trap focus within the modal.
  	const trapFocus = (event) => {
  		if (event.key === 'Tab') {
  			if (firstFocusableElement === lastFocusableElement) {
  				setFocus(firstFocusableElement, event)
  			} else if (event.shiftKey) {
  				if (document.activeElement === firstFocusableElement) {
  					setFocus(lastFocusableElement, event)
  				}
  			} else if (document.activeElement === lastFocusableElement) {
  				setFocus(firstFocusableElement, event)
  			}
  		}
  	}
  		// Function to initialize focus trapping.
  	const activateFocusTrap = () => {
  		const modal = document.querySelector('.modal')
  		if (!modal) {
  			return
  		}
  			const focusableElements = Array.from(
  			modal.querySelectorAll(focusableSelector)
  		)
  		firstFocusableElement = focusableElements[0]
  		lastFocusableElement = focusableElements[focusableElements.length - 1]
  			setFocus(firstFocusableElement)
  			document.addEventListener('keydown', trapFocus)
  	}
  		// Function to deactivate focus trapping
  	const deactivateFocusTrap = () => {
  		document.removeEventListener('keydown', trapFocus)
  	}
  		// MutationObserver to monitor body class changes.
  	const observer = new MutationObserver(() => {
  		if (document.body.classList.contains('modal-open')) {
  			activateFocusTrap()
  		} else {
  			deactivateFocusTrap()
  		}
  	})
  		// Start observing the body element for class attribute changes.
  	observer.observe(document.body, {
  		attributes: true,
  		attributeFilter: ['class'],
  	})
  }
  */
});